module.exports = __webpack_public_path__ + "static/logo-46fab3f67dffa2de06e9622d21babb94.svg";